import { strapiClient } from "@shared/api";
import rebuild from "@shared/api/rebuild";

import { mapDtoToCulturalObjectsPoints } from "../model";

export const getCurrentCulturalObjects = async (
  culturalObjectType: string,
  onResort: boolean,
  pageCount: number,
) => {
  const filters: Record<string, unknown> = {};

  // Add category filter if not "all" - это relation поле
  if (culturalObjectType !== "all") {
    filters.cultural_object_type = {
      uid: {
        $in: [culturalObjectType],
      },
    };
  }

  // Add on resort filter if true - это булевое поле основного объекта
  if (onResort) {
    filters.onResort = {
      $eq: true,
    };
  }

  const searchParams = {
    pagination: {
      page: pageCount || 1,
      pageSize: 6,
    },
    filters: { ...filters },
    sort: ["createdAt:desc"],
    populate: {
      backgroundImage: {
        populate: "*",
      },
      cultural_object_type: {
        populate: "*",
      },
    },
  };

  const culturalObjectsData = strapiClient.collection("cultural-objects");

  const culturalObjects = await culturalObjectsData.find({
    ...searchParams,
  });

  const rebuiltData = rebuild(
    mapDtoToCulturalObjectsPoints(culturalObjects as unknown),
  );

  return rebuiltData;
};
